import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import VitrineNav from '../public/VitrineNav';
import '../public/LandingPage.css';

const TABS = [
  { id: 'mentions', label: 'Mentions legales' },
  { id: 'cgu', label: 'CGU SaaS' },
  { id: 'confidentialite', label: 'Politique confidentialite' },
  { id: 'licence', label: 'Contrat licence SaaS' },
];

/* ═══════════════════════════════════════════════════════════════════════════
 * CE COMPOSANT EST SERVI À DEUX ADRESSES, ET IL DOIT LE SAVOIR
 * ═══════════════════════════════════════════════════════════════════════════
 * ⚠️ DEUX ROUTES, UN SEUL FICHIER : `/legal` (PUBLIC, sans aucune garde) et
 *    `/super-admin/legal` (dans le `SuperAdminLayout`). Voir `AppRouter.jsx:174`
 *    et `:187`. Il rendait la MÊME chose aux deux, ce qui produisait deux
 *    défauts sur la route publique :
 *      ① aucun en-tête de vitrine — ni logo, ni signature GSS-360. Un visiteur
 *        arrivait sur une page de documents juridiques sans marque ;
 *      ② un fil d'Ariane « Dashboard » pointant vers `/super-admin`, montré à
 *        un visiteur ANONYME. Le lien ne donnait aucun accès (la zone est
 *        gardée), mais il annonçait la console d'administration et invitait à
 *        la chercher.
 * ➡️ LE FICHIER N'A PAS BOUGÉ DE PLACE ET AUCUNE ROUTE N'A CHANGÉ (consigne de
 *    Dom). Il lit son propre `pathname` et s'habille en conséquence.
 * ⓘ AUCUN CHANGEMENT SOUS LE SUPER-ADMIN : même page, même fil d'Ariane, même
 *   or. Seule la route publique gagne l'en-tête et perd le lien d'admin.
 * ⓘ LE CONTENU JURIDIQUE EST IDENTIQUE DANS LES DEUX CAS — pas une phrase n'est
 *   réécrite, pas un onglet n'est retiré.
 * ═══════════════════════════════════════════════════════════════════════════ */
export default function LegalPage() {
  const [tab, setTab] = useState('mentions');
  const { pathname } = useLocation();
  const estPublic = !pathname.startsWith('/super-admin');

  const onglets = (
    <div style={{ display: 'flex', gap: 4, marginBottom: 20, flexWrap: 'wrap' }}>
      {TABS.map(t => (
        <button key={t.id} onClick={() => setTab(t.id)} style={{
          padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600,
          background: tab === t.id ? '#C8A84E' : '#1A1A2E', color: tab === t.id ? '#0A0A0F' : '#888',
        }}>{t.label}</button>
      ))}
    </div>
  );

  const corps = (
    <div style={S.card}>
      {tab === 'mentions' && <MentionsLegales />}
      {tab === 'cgu' && <CGU />}
      {tab === 'confidentialite' && <Confidentialite />}
      {tab === 'licence' && <Licence />}
    </div>
  );

  if (estPublic) {
    return (
      <div className="vt">
        <VitrineNav />
        {/* ⓘ `S.page` porte `padding: clamp(12px, 3vw, 28px)`, insuffisant sous une
          *   barre `position: fixed` de 64 px. Les autres pages juridiques
          *   passent par `.vt-legal` (`padding-top: 100px`) ; ici on garde la
          *   mise en page existante de la page et on ajoute la seule réserve
          *   qui manque — 88 px, soit les 64 de la barre plus la respiration. */}
        <div style={{ ...S.page, paddingTop: 88 }}>
          <Link to="/" style={{ color: '#888', fontSize: 12, textDecoration: 'none' }}>← Retour à l&apos;accueil</Link>
          <div style={{ color: '#FFF', fontSize: 14, fontWeight: 700, margin: '8px 0 24px' }}>Documents juridiques</div>
          {onglets}
          {corps}
        </div>
      </div>
    );
  }

  return (
    <div style={S.page}>
      <div style={{ marginBottom: 24 }}>
        <Link to="/super-admin" style={{ color: '#888', fontSize: 12, textDecoration: 'none' }}>Dashboard</Link>
        <span style={{ color: '#444', margin: '0 8px' }}>/</span>
        <span style={{ color: '#FFF', fontSize: 14, fontWeight: 700 }}>Documents juridiques</span>
      </div>
      {onglets}
      {corps}
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: '#C8A84E', marginBottom: 8 }}>{title}</div>
      <div style={{ fontSize: 13, color: '#CCC', lineHeight: 1.7 }}>{children}</div>
    </div>
  );
}

function MentionsLegales() {
  return (
    <>
      <div style={{ fontSize: 18, fontWeight: 800, color: '#FFF', marginBottom: 20 }}>Mentions legales</div>
      <Section title="Editeur">
        SOMABEY Akoété Dominique<br />
        Societe : Gladiator Security Systems<br />
        Intégrateur de systèmes de sécurité — SARL U<br />
        RCCM : TG-LFW-01-2024-B13-00449<br />
        NIF : 1001930788<br />
        CNSS : 183821<br />
        Capital social : 1 000 000 FCFA
      </Section>
      <Section title="Siege social">
        Tokoin-Wuiti, Rue Air-Burkina<br />
        01 BP 126, Lome — Togo
      </Section>
      <Section title="Contact">
        Telephone : +228 92 53 15 14 / 22 61 09 61<br />
        Email : gladiatorsecuritetogo@gmail.com
      </Section>
      <Section title="Hebergement">
        Plateforme GSS-360 hebergee sur serveur securise.<br />
        Donnees stockees conformement a la reglementation togolaise.
      </Section>
    </>
  );
}

function CGU() {
  return (
    <>
      <div style={{ fontSize: 18, fontWeight: 800, color: '#FFF', marginBottom: 20 }}>Conditions Generales d'Utilisation — GSS-360</div>
      <Section title="Article 1 — Objet">
        GSS-360 est une plateforme SaaS de gestion operationnelle destinee aux societes de securite privee.
        Elle permet la gestion des agents, sites, rondes, incidents, facturation, audits et telesurveillance
        depuis une interface web unifiee.
      </Section>
      <Section title="Article 2 — Acces et securite">
        L'acces a la plateforme est protege par authentification JWT avec gestion multi-roles.
        Chaque utilisateur dispose d'identifiants personnels. Le partage de comptes est interdit.
        Les tentatives de connexion sont limitees a 5 essais avec verrouillage de 15 minutes.
      </Section>
      <Section title="Article 3 — Responsabilites de l'editeur">
        L'editeur s'engage a maintenir la plateforme accessible et fonctionnelle.
        Il assure la sauvegarde reguliere des donnees et la correction des anomalies signalees.
        L'editeur ne saurait etre tenu responsable des dommages lies a une utilisation non conforme.
      </Section>
      <Section title="Article 4 — Responsabilites du client">
        Le client est responsable de la confidentialite de ses identifiants, de la veracite des donnees
        saisies et du respect de la reglementation applicable a son activite de securite privee.
      </Section>
      <Section title="Article 5 — Propriete intellectuelle">
        GSS-360, son code source, son architecture et ses interfaces sont la propriete exclusive
        de SOMABEY Akoété Dominique. Toute reproduction, copie ou ingenierie inverse est strictement interdite.
      </Section>
      <Section title="Article 6 — Disponibilite (SLA)">
        L'editeur garantit un taux de disponibilite de 99.5% sur une base mensuelle,
        hors maintenance programmee (communiquee 48h a l'avance) et cas de force majeure.
      </Section>
      <Section title="Article 7 — Resiliation">
        Chaque partie peut resilier l'abonnement avec un preavis de 30 jours.
        En cas de resiliation, les donnees du client sont exportees puis supprimees sous 30 jours.
      </Section>
      <Section title="Article 8 — Droit applicable">
        Les presentes CGU sont soumises au droit togolais.
        Tout litige sera porte devant les tribunaux competents de Lome, Togo.
      </Section>
    </>
  );
}

function Confidentialite() {
  return (
    <>
      <div style={{ fontSize: 18, fontWeight: 800, color: '#FFF', marginBottom: 20 }}>Politique de confidentialite</div>
      <Section title="Donnees collectees">
        La plateforme collecte et traite les donnees suivantes :<br />
        — Agents de securite : identite, matricule, poste, telephone, contrats<br />
        — Clients : raison sociale, contacts, adresses, contrats de prestation<br />
        — Incidents : type, gravite, description, actions prises<br />
        — Utilisateurs : nom, email, role, historique de connexion
      </Section>
      <Section title="Finalite du traitement">
        Les donnees sont traitees exclusivement pour la gestion operationnelle de l'activite
        de securite privee du client : planification, suivi terrain, facturation, conformite.
      </Section>
      <Section title="Duree de conservation">
        Les donnees sont conservees pendant toute la duree de l'abonnement et 12 mois apres resiliation,
        sauf obligation legale de conservation plus longue.
      </Section>
      <Section title="Droits des personnes">
        Conformement a la reglementation, toute personne peut exercer ses droits d'acces,
        de rectification et de suppression en contactant : gladiatorsecuritetogo@gmail.com
      </Section>
      <Section title="Securite des donnees">
        Les donnees sont stockees dans une base PostgreSQL avec isolation par tenant.
        Les mots de passe sont hashes (bcrypt). Les communications sont chiffrees (HTTPS).
      </Section>
      <Section title="Pas de vente a des tiers">
        Gladiator Security Systems s'engage a ne jamais vendre, louer ou partager
        les donnees de ses clients avec des tiers, a des fins commerciales ou autres.
      </Section>
    </>
  );
}

function Licence() {
  return (
    <>
      <div style={{ fontSize: 18, fontWeight: 800, color: '#FFF', marginBottom: 20 }}>Contrat de licence SaaS</div>
      <Section title="Article 1 — Licence d'utilisation">
        L'editeur concede au client une licence d'utilisation non exclusive, non transferable
        et non sous-licenciable de la plateforme GSS-360, pour la duree de l'abonnement souscrit.
      </Section>
      <Section title="Article 2 — Interdictions">
        Le client s'interdit de :<br />
        — Copier, reproduire ou decompiler le logiciel<br />
        — Revendre, sous-licencier ou mettre a disposition de tiers<br />
        — Tenter d'acceder au code source ou a l'infrastructure serveur<br />
        — Utiliser la plateforme a des fins illegales ou non autorisees
      </Section>
      <Section title="Article 3 — Confidentialite">
        Le client s'engage a maintenir la confidentialite de toutes les informations
        techniques relatives a la plateforme. Cette obligation survit a la fin du contrat.
      </Section>
      <Section title="Article 4 — Tarification et paiement">
        La tarification est basee sur le nombre d'agents actifs et les modules souscrits.
        Le paiement est du mensuellement, d'avance, aux conditions convenues lors de la souscription.
        Tout retard de paiement superieur a 15 jours entraine la suspension de l'acces.
      </Section>
      <Section title="Article 5 — Resiliation et consequences">
        En cas de resiliation :<br />
        — L'acces a la plateforme est desactive a la fin de la periode payee<br />
        — Les donnees sont exportees au format Excel sous 15 jours<br />
        — Les donnees sont supprimees definitivement sous 30 jours<br />
        — Aucun remboursement des periodes non utilisees
      </Section>
      <Section title="Article 6 — Force majeure">
        Aucune des parties ne sera tenue responsable en cas de force majeure :
        catastrophe naturelle, panne reseau nationale, cyberattaque de grande ampleur,
        decision gouvernementale ou tout evenement imprevisible et irresistible.
      </Section>
    </>
  );
}

const S = {
  page: { minHeight: '100vh', maxWidth: '100%', boxSizing: 'border-box', background: '#0A0A0F', padding: 'clamp(12px, 3vw, 28px)' },
  card: { background: '#111122', borderRadius: 12, padding: 'clamp(12px, 3vw, 28px)', border: '1px solid #1A1A2E', minWidth: 0 },
};
